import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginFormTW } from '../../components/auth/LoginFormTW';
import { useAuth } from '../../contexts/AuthContext';
import { useLenis } from '../../hooks/useLenis';

export const LoginPageTW: React.FC = () => {
  useLenis(); // Smooth scrolling aktivieren

  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  // Get redirect path from URL params or state.
  // User ohne aktives Abo wird von ProtectedRoute ohnehin auf /pakete
  // geleitet — Login schickt ihn standardmäßig nach /dashboard, dort übernimmt
  // dann der Subscription-Guard.
  const redirectTo = new URLSearchParams(location.search).get('redirect') ||
                     (location.state as any)?.from?.pathname ||
                     '/dashboard';

  // Bereits eingeloggte User direkt weiterleiten (z.B. nach Refresh oder
  // wenn jemand /login mit gueltiger Session aufruft).
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, redirectTo]);

  const handleLoginSuccess = () => {
    navigate(redirectTo, { replace: true });
  };

  // Nur bei initialem Auth-Check (vor First-Render) oder bei erkanntem Login
  // nichts rendern. WICHTIG: `isLoading` wird auch durch LOGIN_START/LOGIN_FAILURE
  // gesetzt — würden wir auf isLoading prüfen, würde LoginFormTW während des
  // Login-Versuchs unmounted und nach LOGIN_FAILURE frisch gemountet (alle
  // State weg: step springt auf 'identifier', formData wird geleert).
  // Daher: nur bei isAuthenticated null rendern, nicht bei isLoading.
  if (isAuthenticated) {
    return null;
  }

  return (
    <LoginFormTW
      onSwitchToRegister={() => navigate('/pakete')}
      onLoginSuccess={handleLoginSuccess}
    />
  );
};
